export default __webpack_public_path__ + "media/images/users/user-peter-johnson-70x70-082dfdf7a1e7f65ca8e5c0a8913d7417.jpg";